<template>
    <v-flex xs12 class="businesses_list inner-scrollbar">
        <v-layout row wrap>
            <v-flex xs12 v-for="(result,i) in businessesData" :key="i" class="businesses_list__rows">
                <v-layout row wrap>
                    <v-flex xs9 sm8 class="businesses_list__row">
                        <v-flex class="name">
                            <v-flex mr-1 @click="openBusinessesInfo(result)" :data-qe-id="'business_name_link'+i" tag="span">{{result.name}}</v-flex>
                            <v-tooltip slot="append" right v-if="getYpoOwned(result.personAssetRelation)">
                                <icon-ypo-logo width="14" height="14" slot="activator"></icon-ypo-logo>
                                <span>{{businessesConstants.YPO_MEMBER_OWNED}}</span>
                            </v-tooltip>
                        </v-flex>
                        <v-flex tag="small">{{result.address1}} {{getCity(result)}}</v-flex>
                        <v-flex tag="strong">{{getCuisineType(result)}}
                            <v-flex tag="em">{{result.priceRange}}</v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex xs3 sm4>
                        <v-img height="76px" contain></v-img>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    import { isNullOrUndefined } from 'util';
    import IconYpoLogo from "../Icons/IconYpoLogo";
    import { businessesConstants } from './businesses.constants';
    import { storeMutation } from "../../store/storeMutations.constant";
    import { mapMutations } from "vuex";
    import { gaDataLayerEvent } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";

    export default {
        name: 'BusinessesList',
        components: {
            IconYpoLogo,
        },
        data: () => ({
            businessesConstants,
            personAssetRelation: [],
        }),
        props: {
            businessesData: {
                type: Array,
                required: false,
            },
        },
        methods: {
            getCuisineType(value) {
                if (value.cuisineType && value.priceRange) {
                    return `${value.cuisineType} | `;
                }
                if (value.cuisineType) {
                    return `${value.cuisineType}`;
                }      
            },
            getCity(value) {
                if (value.city && value.state && value.zip && value.country) {
                    return `${value.city}, ${value.state} ${value.zip}, ${value.country}`;
                }
                if (isNullOrUndefined(value.state)) {
                    return `${value.city}, ${value.zip}, ${value.country}`;
                }
                return `${value.city}, ${value.state} ${value.zip}, ${value.country}`;
            },
            getYpoOwned(personAssetRelation) {
                if (personAssetRelation && personAssetRelation.length > 0) {
                    return personAssetRelation.some(element => element.relationshipToAsset !== this.businessesConstants.ASSET_RELATION_NONE);
                }
                return false;
            },
            openBusinessesInfo(result) {
                this.setShowAssetId(result.id);
                const establishmentSelectedInfo = `${result.name || ''} | ${result.city || ''} | ${result.country || ''}`;
                gaDataLayerEvent(gtmEventName.C_Around_Me_Establishment_Selected, establishmentSelectedInfo);
            },
            ...mapMutations({
                setShowAssetId: `businesses/${[storeMutation.setShowAssetId]}`,
            }),
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .businesses_list {
        max-height: 650px;
        overflow-y: auto;
        margin-top: 20px;

        &__row {
            margin: 0px;
        }
        &__rows {
            border-bottom: 1px solid rgba($ypo-medium-gray, 0.5);
            padding: 7px 0;
            .v-image {
                height: auto !important;
            }
            .name {
                font-size: 14px;
                color: $ypo-cta;
                display: block;
                cursor: pointer;
                margin-right: 4px;
            }
            strong {
                font-size: 12px;
                color: rgba($ypo-gray-text, 0.8);
                font-weight: 400;
                display: block;
                em {
                    color: $ypo-gold;
                    font-style: normal;
                }
            }
            small {
                color: rgba($ypo-gray-text, 0.8);
                font-size: 12px;
            }
        }
        @include breakpoint(xs) {
            max-height: inherit;
            padding: 0px;
            &__row {
                margin: 0px;
            }
            &__rows {
                border-bottom: 1px solid rgba($ypo-medium-gray, 0.5);
                padding: 7px 0;
                .v-image {
                    height: auto !important;
                }
                .name {
                    font-size: 14px;
                    color: $ypo-cta;
                    display: block;
                }
                strong {
                    font-size: 12px;
                    color: rgba($ypo-gray-text, 0.8);
                    font-weight: 400;
                    display: block;
                    em {
                        color: $ypo-gold;
                        font-style: normal;
                    }
                }
                small {
                    color: rgba($ypo-gray-text, 0.8);
                    font-size: 12px;
                }
            }
        }
    }
</style>        
